import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider }   from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import Landing    from './components/Landing';
import Login      from './pages/Login';
import Dashboard  from './pages/Dashboard';
import TableView  from './pages/TableView';
import AdminTables from './pages/AdminTables';
import AuthLayout from './layouts/AuthLayout';

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
      <BrowserRouter basename={process.env.REACT_APP_BASE_PATH || ''}>
        <Routes>
          <Route path="/"      element={<Landing />} />
          <Route path="/login" element={<Login />} />

          <Route element={<AuthLayout />}>
            <Route path="/dashboard"  element={<Dashboard />} />
            <Route path="/table/:id"  element={<TableView />} />
            <Route path="/admin/tables" element={<AdminTables />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
